module.exports = __webpack_public_path__ + "static/media/binder-70.cbf27d5e.png";